// extracted by mini-css-extract-plugin
module.exports = {"ConfirmUI":"ConfirmUI_ConfirmUI__VH1hY","accountCreationForm_button":"ConfirmUI_accountCreationForm_button__2YTUn","btnOutlined":"ConfirmUI_btnOutlined__lTVvX"};